import { Injectable } from "@angular/core";
import { ContractsService } from "../contracts.service";
import { Web3Service } from "app/services/web3/web3.service";
import { Observable, first, from } from "rxjs";
import { eContracts } from "../contract.config";

@Injectable({
    providedIn: 'root'
})

export class LootboxesContractService {
    private contract;
    constructor(
        private contractsService: ContractsService,
        private web3Service: Web3Service
    ) {
        // this.contractsService.setContract(this.web3Service.getWeb3(), eContracts.Lootbox);
        // this.contractsService.getContractIstances(eContracts.Lootbox).pipe(first()).subscribe(c => this.contract = c);
        this.contract = this.contractsService.getContract( eContracts.Lootbox);

    }

    buyItem(ownerAddress: string, boxId: string, amount: number): Observable<any> {
        return from(this.contract.methods.buyItem(ownerAddress, boxId, amount).send({
            from: ownerAddress
        }))
    }
}